import Select, { SelectProps } from "@mui/material/Select";

import classNames from "classnames";
import { useTranslation } from "next-i18next";

export interface OptionProps extends React.HTMLProps<HTMLOptionElement> {
  children?: React.ReactNode;
  className?: string;
}

export type Props = SelectProps & {
  children: React.ReactNode;
  className?: string;
  title?: string;
  pattern?: string;
  required?: boolean;
};

function Option(props: Readonly<OptionProps>) {
  const { children, className, ...otherProps } = props;
  return (
    <option className={classNames([className])} {...otherProps}>
      {children}
    </option>
  );
}
function MySelect(props: Props) {
  const { children, className, required, ...otherProps } = props;
  let { title } = props;

  const { t } = useTranslation();

  if (!title && required) {
    title =
      t("Please select an item in the list") ||
      "Please select an item in the list";
  }
  let inputProps: { [key: string]: string | boolean } = {};
  if (title) {
    inputProps.title = title;
  }
  if (required) {
    inputProps.required = required;
  }

  return (
    <Select
      native
      className={classNames([className, "sebkort-brand-select"])}
      inputProps={{
        "data-adobe-eventname": "interaction",
        "data-adobe-eventcategory": "contact",
        ...inputProps,
        ...otherProps.inputProps,
      }}
      {...otherProps}
    >
      {children}
    </Select>
  );
}

export { MySelect as Select, Option };
